export var preAuthCode = "_AUTH_CODE";
